import LibraryBadges from "@/components/reading/LibraryBadges";

const mmss = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

// Parent report: library texts read in the last 7 days, with each reading time
export default function LibraryWeek({ rep, lang }) {
  const fr = lang === "fr";
  const rows = ["en", "fr"].flatMap((l) => (rep[l]?.library_week || []).map((r) => ({ ...r, lang: l })));
  return (
    <div className="mt-4 rounded-xl bg-emerald-50 p-4 text-sm" data-testid="reading-report-library">
      <p className="font-bold mb-1">{fr ? "Bibliothèque · textes lus cette semaine" : "Library · texts read this week"}</p>
      <p className="text-xs text-slate-600 mb-2">{fr ? "Vous pouvez écouter votre enfant dans ses enregistrements, plus bas." : "You can listen to your child in the recordings below."}</p>
      <LibraryBadges badges={rep.library_badges} streak={rep.library_streak} lang={lang} compact />
      {!rows.length ? <p className="text-slate-500 mt-2" data-testid="reading-report-library-empty">{fr ? "Aucun texte de la bibliothèque lu cette semaine." : "No library text read this week."}</p> : (
        <ul className="mt-2 space-y-1.5">
          {rows.map((r) => (
            <li key={r.id} className="flex flex-wrap items-center gap-2" data-testid={`reading-report-lib-${r.id}`}>
              <span className="rounded-full bg-white border px-2 text-xs font-bold">{r.lang.toUpperCase()}</span>
              <b>{r.title}</b>
              <span className="text-slate-500">{r.level_name} · {r.words} {fr ? "mots" : "words"}</span>
              <span className="text-slate-700" data-testid={`reading-report-lib-times-${r.id}`}>
                {fr ? "Temps :" : "Time:"} {r.seconds.map(mmss).join(", ")}{r.best ? ` · ${fr ? "meilleur" : "best"} ${mmss(r.best)}` : ""}
              </span>
              {!r.finished && <span className="text-xs text-amber-700">{fr ? "(lu trop vite)" : "(read too fast)"}</span>}
              {r.finished && !r.proven && <span className="text-xs text-amber-700" data-testid={`reading-report-lib-unproven-${r.id}`}>{fr ? "(sans enregistrement)" : "(no recording)"}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
